import {
  GET_MASTER_REPORTING_ITEM_LIST,
  GET_MASTER_REPORTING_ITEM_LIST_SUCCESS,
  GET_MASTER_REPORTING_ITEM_LIST_FAILURE,
  GET_MASTER_REPORTING_ITEM_DATA,
  GET_MASTER_REPORTING_ITEM_DATA_SUCCESS,
  GET_MASTER_REPORTING_ITEM_DATA_FAILURE,
} from "./actionType";

// Reducer
const initialState = {
  masterReportingItemList: [],
  masterReportingItemListLoading: false,
  masterReportingItemListError: null,
  masterReportingItemData: [],
  masterReportingItemDataLoading: false,
  masterReportingItemDataError: null,
};

const ReportingDashboard = (state = initialState, action) => {
  switch (action.type) {
    case GET_MASTER_REPORTING_ITEM_LIST:
      return {
        ...state,
        masterReportingItemListLoading: true,
        masterReportingItemListError: null,
      };
    case GET_MASTER_REPORTING_ITEM_LIST_SUCCESS:
      return {
        ...state,
        masterReportingItemList: action.payload,
        masterReportingItemListLoading: false,
      };
    case GET_MASTER_REPORTING_ITEM_LIST_FAILURE:
      return {
        ...state,
        masterReportingItemListLoading: false,
        masterReportingItemListError: action.payload,
      };
    case GET_MASTER_REPORTING_ITEM_DATA:
      return {
        ...state,
        masterReportingItemDataLoading: true,
        masterReportingItemDataError: null,
      };
    case GET_MASTER_REPORTING_ITEM_DATA_SUCCESS:
      return {
        ...state,
        masterReportingItemData: action.payload,
        masterReportingItemDataLoading: false,
      };
    case GET_MASTER_REPORTING_ITEM_DATA_FAILURE:
      return {
        ...state,
        masterReportingItemDataLoading: false,
        masterReportingItemDataError: action.payload,
      };
    default:
      return state;
  }
};

export default ReportingDashboard;
